var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMynotices03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.714,
    height: 20,
    viewBox: "0 0 15.714 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-download-file-3546649",
    fill: "#002a57",
    d: "M173.053,39.542l-3.571-4.286a.715.715,0,0,0-.55-.257H158.217a.714.714,0,0,0-.714.714V54.285a.714.714,0,0,0,.714.714H172.5a.714.714,0,0,0,.714-.714V40a.715.715,0,0,0-.164-.457Zm-3.407-1.857,1.329,1.6h-1.329Zm2.143,15.886H158.932V36.428h9.286V40a.714.714,0,0,0,.714.714h2.857Zm-3.064-7.65a.714.714,0,0,1,0,1.014l-2.857,2.857a.714.714,0,0,1-1.014,0L162,46.935a.717.717,0,0,1,1.014-1.014l1.636,1.643V42.142a.714.714,0,1,1,1.429,0v5.421l1.636-1.643a.714.714,0,0,1,1.014,0Z",
    transform: "translate(-157.503 -34.999)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMynotices03);
export default __webpack_public_path__ + "static/media/Mynotices-03.9f65bf6f54b7db7b6ebee92a26668172.svg";
export { ForwardRef as ReactComponent };